<template>
  <div id="app">
    <!-- 导航栏 -->
    <div class="header-container">
      <h1 class="system-title">禄杰物流管理系统</h1>
      <div class="header-right">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          text-color="#fff" active-text-color="#fff" background-color="#1C1C1C">
          <el-menu-item index="1">
            首页
          </el-menu-item>
          <el-menu-item index="2" style="margin-left: 100px;">
            查询订单
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <!-- 主内容区 -->
    <main class="main-container">
      <keep-alive include="Home,OrderQuery">
        <router-view />
      </keep-alive>
    </main>
    <!-- 页脚 -->
    <div class="footer-container">
      <div class="footer-content">
        <img src="@/assets/images/1.png" alt="" class="footer-logo">
        <div class="footer-contact">
          <div class="contact-item flex align-center">
            <img src="@/assets/images/2.png" alt="" class="contact-icon">
            <div class="contact-text">
              <div class="contact-title">服务热线</div>
              <div class="contact-number">{{ tel }}</div>
            </div>
          </div>
          <div class="contact-address">地址：{{ company_addr }}</div>
        </div>
      </div>
      <div class="footer-copyright">{{ copyright }}</div>
    </div>
  </div>
</template>

<script>
import { getHomeData } from '@/api/home.js'
export default {
  name: 'App',
  data() {
    return {
      activeIndex: '1',
      tel: '',
      company_addr: '',
      copyright: '',
    }
  },
  mounted() {
    this.getHomeData();
    // 初始化时根据当前路由设置高亮状态
    this.updateActiveIndex();
  },
  created() {
    // 监听路由变化，自动更新高亮状态
    this.$router.afterEach((to, from) => {
      this.updateActiveIndex();
    });
  },
  methods: {
    getHomeData() {
      getHomeData({}).then(res => {
        if (res.code == '1') {
          let data = res.data;
          this.tel = data.tel;
          this.company_addr = data.company_addr;
          this.copyright = data.copyright;
        }
      })
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      if (key === '1' && this.$route.path !== '/') {
        this.$router.push('/')
      } else if (key === '2' && this.$route.path !== '/order-query') {
        this.$router.push('/order-query')
      }
    },
    // 根据当前路由更新高亮状态
    updateActiveIndex() {
      const path = this.$route.path;
      if (path === '/') {
        this.activeIndex = '1'; // 首页
      } else if (path === '/order-query' || path === '/order-detail') {
        this.activeIndex = '2'; // 查询订单及其子页面
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.header-container {
  background-color: #1C1C1C;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 40px;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.system-title {
  font-size: 24px;
  font-weight: 600;
}

.header-right {
  margin-left: 150px;
}

/* 使用更高优先级的选择器覆盖Element UI默认样式 */
.header-right .el-menu.el-menu--horizontal {
  border: none;
}

.header-right .el-menu--horizontal>.el-menu-item {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
}

/* 去除router-link下划线 */
.header-right .el-menu--horizontal .el-menu-item a {
  text-decoration: none !important;
  color: #fff;
}

/* 选中的下划线颜色 - 使用!important确保覆盖 */
.header-right .el-menu--horizontal .el-menu-item.is-active::after {
  border-color: #5C95E0 !important;
}

.main-container {
  min-height: calc(100vh - 120px);
  padding-top: 60px;
}

.footer-container {
  background-color: #1C1C1C;
}

.footer-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 52px 260px;
  border-bottom: 1px solid #575757;
}

.footer-logo {
  width: 168px;
  height: 66px;
}

.contact-icon {
  width: 38px;
  height: 38px;
}

.contact-text {
  margin-left: 20px;
}

.contact-title {
  font-weight: 400;
  font-size: 12px;
  color: #E0E0E0;
}

.contact-number {
  font-weight: bold;
  font-size: 26px;
  color: #FFFFFF;
}

.contact-address {
  font-weight: 400;
  font-size: 14px;
  color: #E0E0E0;
  margin-top: 20px;
}

.footer-copyright {
  font-weight: 400;
  font-size: 14px;
  color: #6E6E6E;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 响应式布局样式 */
@media (max-width: 1200px) {
  .header-container {
    padding: 0 30px;
  }

  .footer-content {
    padding: 45px 150px;
  }
}

@media (max-width: 992px) {
  .system-title {
    font-size: 22px;
  }

  .header-right {
    margin-left: 100px;
  }

  .header-right .el-menu--horizontal>.el-menu-item {
    font-size: 15px;
  }

  .el-menu-item[index="2"] {
    margin-left: 60px !important;
  }

  .footer-content {
    padding: 40px 100px;
  }

  .footer-logo {
    width: 150px;
    height: 60px;
  }

  .contact-number {
    font-size: 24px;
  }

  .contact-address {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 20px;
    flex-direction: column;
    height: auto;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .system-title {
    margin-bottom: 10px;
    font-size: 20px;
  }

  .header-right {
    margin-left: 0;
    width: 100%;
  }

  .el-menu-item[index="2"] {
    margin-left: 50px !important;
  }

  .footer-content {
    flex-direction: column;
    padding: 35px 50px;
    text-align: center;
  }

  .footer-logo {
    margin-bottom: 25px;
  }

  .contact-item {
    justify-content: center;
  }

  .contact-number {
    font-size: 22px;
  }
}

@media (max-width: 576px) {
  .system-title {
    font-size: 18px;
  }

  .header-right .el-menu--horizontal>.el-menu-item {
    font-size: 14px;
    padding: 0 10px;
  }

  .el-menu-item[index="2"] {
    margin-left: 30px !important;
  }

  .footer-content {
    padding: 30px 20px;
  }

  .footer-logo {
    width: 130px;
    height: 52px;
  }

  .contact-icon {
    width: 32px;
    height: 32px;
  }

  .contact-text {
    margin-left: 15px;
  }

  .contact-number {
    font-size: 20px;
  }

  .contact-address {
    font-size: 12px;
    margin-top: 15px;
  }
}
</style>